import { NewsTabCategory } from './NewsTabCategory';

export enum NewsCategory {
    None = "None",
    Events = "Event",
    Primary = "Primary",
    Research = "Research",
    Secondary = "Secondary",
    MyPortfolio = "MyPortfolio",
    CleansingNotice = "CleansingNotice",
    RatingAction = "RatingAction",
    PeopleAndFunds = "PeopleAndFunds",
}

export const newsCategoryTitles = {
    [NewsCategory.None]: "—",
    [NewsCategory.Events]: "Events",
    [NewsCategory.Primary]: "Primary",
    [NewsCategory.Research]: "Research",
    [NewsCategory.Secondary]: "Secondary",
    [NewsCategory.MyPortfolio]: "My Portfolio",
    [NewsCategory.CleansingNotice]: "Cleansing Notice",
    [NewsCategory.RatingAction]: "Rating Action",
    [NewsCategory.PeopleAndFunds]: "People and Funds",
};

export const NewsTabToCategory: Partial<Record<NewsTabCategory, NewsCategory>> = {
    [NewsTabCategory.Primary]: NewsCategory.Primary,
    [NewsTabCategory.Secondary]: NewsCategory.Secondary,
    [NewsTabCategory.Research]: NewsCategory.Research,
    [NewsTabCategory.CleansingNotice]: NewsCategory.CleansingNotice,
    [NewsTabCategory.RatingAction]: NewsCategory.RatingAction,
    [NewsTabCategory.PeopleAndFunds]: NewsCategory.PeopleAndFunds,
};
